import * as React from 'react';
import { SVGProps } from 'react';

const IconOilBarrelSizeL = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M5.5 6h17a1.5 1.5 0 0 0 0-3h-1.585a1.5 1.5 0 0 0-2.83 0H5.5a1.5 1.5 0 0 0 0 3Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 8h16v6h.5a1.5 1.5 0 0 1 0 3H22v6h.5a1.5 1.5 0 0 1 0 3h-17a1.5 1.5 0 0 1 0-3H6v-6h-.5a1.5 1.5 0 0 1 0-3H6V8Zm11.5 9.5a3.5 3.5 0 1 1-7 0C10.5 15 14 11 14 11s3.5 4 3.5 6.5Z"
    />
  </svg>
);
export default IconOilBarrelSizeL;
